//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
        .directive('socialItem', () => ({
          restrict: 'E',
          scope: {
            network: '@',
            large: '@',
          },
          template: '<div class="social-item">' +
                    '<social-icon network="{{network}}" large="{{large}}" muted="false"></social-icon>' +
                    '<span class="content" ng-transclude></span>' +
                '</div>',
          transclude: true,
        }));
})();
